import { motion } from 'framer-motion';
import { Clock, Palette, Briefcase, Layers } from 'lucide-react';

const features = [
  {
    icon: Clock,
    title: 'Save Hours of Work',
    description: 'No more starting designs from scratch. Pick a template, edit, and post in minutes.',
  },
  {
    icon: Palette,
    title: 'Fully Editable PSDs',
    description: 'Change text, colors, photos — everything is organized in clean layers. Works in Photoshop.',
  },
  {
    icon: Briefcase,
    title: 'Commercial-Use Ready',
    description: 'Use for your business, clients, social media, or sell your design services. No restrictions.',
  },
  {
    icon: Layers,
    title: '3 Categories in 1 Pack',
    description: 'Flyers & posters, product mockups, and PSD text effects — 250 templates total.',
  },
];

const styles = {
  section: {
    padding: '100px 20px',
    background: '#ffffff',
  },
  container: {
    maxWidth: '1100px',
    margin: '0 auto',
  },
  heading: {
    textAlign: 'center',
    fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
    fontWeight: 800,
    color: '#0a0a0a',
    marginBottom: '12px',
  },
  subheading: {
    textAlign: 'center',
    fontSize: '1.1rem',
    color: '#6b7280',
    marginBottom: '60px',
    maxWidth: '550px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '32px',
  },
  card: {
    padding: '32px',
    borderRadius: '16px',
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  iconWrapper: {
    width: '52px',
    height: '52px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(8,246,84,0.08)',
    marginBottom: '20px',
  },
  cardTitle: {
    fontSize: '1.15rem',
    fontWeight: 700,
    color: '#0a0a0a',
    marginBottom: '10px',
  },
  cardDesc: {
    fontSize: '0.95rem',
    color: '#6b7280',
    lineHeight: 1.6,
  },
};

function Features() {
  return (
    <section id="features" style={styles.section}>
      <div style={styles.container}>
        <h2 style={styles.heading}>Why You'll Love This Pack</h2>
        <p style={styles.subheading}>
          Everything you need to make your brand look professional — without hiring a designer.
        </p>
        <div style={styles.grid}>
          {features.map((feature, index) => (
            <motion.div
              key={index}
              style={styles.card}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ transform: 'translateY(-4px)', boxShadow: '0 8px 30px rgba(0,0,0,0.08)' }}
            >
              <div style={styles.iconWrapper}>
                <feature.icon size={24} color="#08F654" />
              </div>
              <h3 style={styles.cardTitle}>{feature.title}</h3>
              <p style={styles.cardDesc}>{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
